<template>
  <Survey360ResultsView
    :surveyResult="surveyResult"
    :roles="roles"
    :clang="state.clan"
    :loading="loading"
    :subjectName="target"
  />
</template>

<script setup>
import Survey360ResultsView from "@/components/Survey360ResultsView";

import { computed, onMounted, reactive, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

const route = useRoute();
const surveyId = route.params.id;
const store = useStore();
const loading = ref(true);

const state = reactive({
  role: computed(() => store.state.survey360.roles),
  clan: computed(() => store.state.survey.currentLanguage),
});

window.onresize = () => {};

async function setupData() {
  if (route.name === "targetSurvey360Results") {
    console.log("Fetch for user");
    await store.dispatch("survey360/fetchTargetRoles", route.params.id);
    if (state.role && state.role.length === 0) return;
    store.dispatch("results/fetchTargetSurvey360Answers", { surveyId });
  } else {
    await store.dispatch("survey360/fetchRoles", route.params.id);
    if (state.role && state.role.length === 0) return;
    store.dispatch("results/fetchSurvey360Answers", { surveyId });
  }
}

const roles = computed(() => store.getters["survey360/getRoles"]);

const surveyResult = computed(() => {
  const data = store.state.results.survey360Data;
  return data[surveyId]?.["all"] ?? {};
});

const target = computed(() => surveyResult.value.target ?? "");

watch(surveyResult, (newResults) => {
  if (newResults !== {}) {
    loading.value = false;
  }
});

onMounted(() => {
  setupData();
});
</script>
